<template>
  <section class="n-footer">
    <div class="info">
      <p class="desc">
        千途导摄平台是一个集拍摄地导航、智能修图、摄影比赛、网络教学、网络存储、摄影旅游、图片分享销售、摄影学习互动于一体的综合性互联网摄影服务平台。
      </p>
      <p class="nav">
        <a href="https://www.pai2345.com/web/Index/aboutus">关于千途</a
        ><span class="icon-line">|</span>
        <a href="http://edu.pai2345.com/">云课堂</a
        ><span class="icon-line">|</span>
        <a href="https://www.pai2345.com/web/Index/help">使用指南</a
        ><span class="icon-line">|</span>
        <a href="https://www.pai2345.com/web/Index/aips" target="_blank"
          >一键修图</a
        ><span class="icon-line">|</span>
        <a href="https://www.pai2345.com/web/Index/assistant">修图助手</a
        ><span class="icon-line">|</span>
        <a
          target="_blank"
          href="http://wpa.qq.com/msgrd?v=3&amp;uin=3298507498&amp;site=qq&amp;menu=yes"
          >在线客服</a
        ><span class="icon-line">|</span>
        <a href="javascript:void (0);" onclick="feedback()">意见反馈</a
        ><span class="icon-line">|</span>
        <a href="https://www.pai2345.com/web/Index/disclaimer">免责声明</a>
      </p>
    </div>
    <div class="qr">
      <img
        src="https://www.pai2345.com/static/web/res/images/code.png"
        alt=""
      />
      <div>
        <p>下载千途App</p>
        <p>手机上查看与分享修图作品</p>
      </div>
    </div>
    <div class="copyright">
      <p class="icp">
        ©2019 福州全摄汇网络科技有限公司版权所有
        <a
          target="_blank"
          href="https://beian.miit.gov.cn/"
          style="display:inline-block;vertical-align: middle;"
          ><img
            src="https://www.pai2345.com/static/web/res/images/beian-icon.png"
            style="float:left;"
          /><span style="margin: 0px 0px 0px 5px;">闽ICP备19009816号-2</span></a
        >
        <span style="margin: 0px 0px 0px 5px;">客服热线：0591-38700510</span>
      </p>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.n-footer {
  box-sizing: border-box;
  width: 1380px;
  margin: 0 auto;
  padding: 30px 30px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  color: #666;
  a {
     color: #666;
  }
  .info {
    width: 760px;
    .desc {
      line-height: 30px;
      margin-bottom: 16px;
    }
  }
  .nav {
  }
  .icon-line {
    margin: 0 6px;
  }
  .qr {
    display: flex;
    align-items: center;
    width: 314px;
    > img {
      width: 120px;
      height: 120px;
      margin-right: 20px;
    }
  }
}
</style>
